// extracted by mini-css-extract-plugin
export default {"Loader":"Progressbar_Loader__3JEaQ","load2":"Progressbar_load2__lHxEF"};